import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { Box, Button, CircularProgress, Typography } from "@material-ui/core";
import SongEditPage from "./SongEditPage";
import songsAPI from "restApi/songsApi";

export default () => {
  const { id } = useParams();
  const history = useHistory();
  const [song, setSong] = React.useState({ loading: true });

  // Both "cancel" and "saved" return to the view page - it always
  // refetches fresh on mount, so a save's result is picked up
  // automatically without this container needing to hand anything back.
  const goToView = () => history.push(`/songs/${id}`);
  // After saving lyrics onto a song that had none, the song page says thank you.
  const goToViewAfterSave = (saved, info) =>
    history.push(`/songs/${id}`, info && info.addedLyrics ? { lyricsThanks: true } : undefined);
  const goToCatalog = () => history.push("/catalog");

  React.useEffect(() => {
    songsAPI.getSong(id).then(
      (res) => setSong({ loading: false, ...res.data }),
      // A bad/missing id (a stale link, or an `undefined` that slipped
      // through from a caller - see SongCard.jsx's songIdFromUrl for a
      // fix of exactly that), or switching to a team that doesn't have
      // this song, would otherwise leave `loading: true` forever, with
      // nothing on screen but a spinner and no explanation.
      () => setSong({ loading: false, notFound: true })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (song.notFound) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" mt={8} px={2} textAlign="center">
        <Typography variant="h6" gutterBottom>
          Can't find this song
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          It may belong to a different team than the one you're currently on.
        </Typography>
        <Box mt={2}>
          <Button variant="outlined" onClick={goToCatalog}>
            Go back
          </Button>
        </Box>
      </Box>
    );
  }

  if (song.loading) {
    return (
      <Box display="flex" justifyContent="center" mt={8}>
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  return <SongEditPage song={song} onSaved={goToViewAfterSave} onCancel={goToView} />;
};
